






import {Vue, Component} from 'vue-property-decorator';

interface Module {
    key: string;
    title: string;
    icon: string;
}

@Component
export default class App extends Vue {

    // Drawer open/close
    protected drawer: boolean = true;

    // Modules
    protected modules: Module[] = [
        {
            key: 'challenges',
            title: 'Challenges',
            icon: 'mdi-pencil-box-multiple-outline',
        },
        {
            key: 'participants',
            title: 'Participants',
            icon: 'mdi-account-group',
        },
    ];
    protected activeModuleKey: string = this.modules[0].key;

    protected get activeModule(): Module | null {
        let module: Module | null = null;
        for (const m of this.modules) {
            if (m.key === this.activeModuleKey) {
                module = m;
            }
        }
        return module;
    }

    protected onModuleClicked(module: Module) {
        this.activeModuleKey = module.key;
        this.$router.push({name: module.key});
    }

}
